import { bannerManager } from '@envato/foundation-types'

import { ActionTypes, TypeKeys } from '../actions/marketing/banner'

export interface IState {
  readonly banners: bannerManager.headerBanners.IResult
}

const initialState: IState = {
  banners: []
}

export const reducer = (state = initialState, action: ActionTypes): IState => {
  switch (action.type) {
    case TypeKeys.GET_BANNER_SUCCESS:
      const banners = action.payload
      return {
        ...state,
        banners
      }

    default:
      return state
  }
}
